import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
export var Customs = function Customs(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return customsBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return customsBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var customsBuilder = function customsBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "JmmgSz",
        defaultMessage: [{
          "type": 0,
          "value": "Contactar o revendedor sobre o desalfandegamento"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "Gb5Uqe",
        defaultMessage: [{
          "type": 0,
          "value": "Se precisar de informações do revendedor para garantir que a sua encomenda é desalfandegada, envie uma mensagem diretamente ao revendedor. Caso surjam quaisquer outros problemas, contacte-nos."
        }]
      })];
    }
  };
};